export default "__VITE_ASSET__7PUm3F_uVf$21BIFLSklvQ__"